import React from 'react';
import classNames from 'classnames';

import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

interface WizardPoint {
	label: string;
	iconName?: string | null;
	order?: number | null;
	showInWizard: boolean;
}

interface Props {
	attributes?: WizardPoint[] | null;
	className?: string;
}

/**
 * The few points an operator ticked `In the wizard`, beside the fare type they describe.
 *
 * <p>Spans rather than a list: the Seats step draws this inside the fare type's own button, where
 * block content is not allowed. Each point takes its own line either way.</p>
 */
export default function ClassWizardPoints({ attributes, className }: Props) {
	const points = (attributes ?? [])
		.filter(x => x.showInWizard)
		.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

	if (points.length === 0) {
		return null;
	}

	return (
		<span className={classNames('flex flex-col gap-0.5 text-xs text-gray-700', className)}>
			{points.map(point => (
				<span key={point.label} className="flex items-center gap-1.5">
					{/* A tick where there is no icon, as the information panel does. */}
					{point.iconName ? <Icon name={point.iconName} useMaterialIcons /> : <Icon name="tick" />}
					<span>{point.label}</span>
				</span>
			))}
		</span>
	);
}
